module.exports = __webpack_public_path__ + "files/117bbed5ccf0ad65d891a3a022ed6cfc.png";